import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { dtactionStore } from "../dtactions/dtaction-store";
import Api from "../state/Api";
import { Cols, Col8, Col3, Col5, Col4 } from "../Controls";
import { commodityType, commodityType1 } from "../util/commodityType";
import {
  bookingsStore,
  configStore,
  containerStore,
  contractsStore,
} from "../state/CommonState";
import EntityApi from "../state/entities-api";
import Utils from "../util/Utils";
import { taskStore } from "./task-store";
import { loader } from "../util/loader";
import { commodityList, hazardousList } from "../StaticData";
import MonApi, { UPDATE_BOOKING_FIELDS_URI } from '../state/mongo-api';

export default function ProceedPopup({ data }) {
  useSnapshot(dtactionStore);
  useSnapshot(configStore);

  let options = ["Yes", "No"];
  const [selected, setSelected] = useState(null);
  function onChange(i) {
    setSelected((prev) => (i === prev ? null : i));
  }

  let modalClass = "modal";
  if (configStore.coiModalVisible1) modalClass += " is-active";
  const offerPremiumValue = 500

  return (
    <div className={modalClass}>
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
          e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
          <p
            style={{
              marginTop: "20px",
              padding: "10px 14px",
              background: "#fff8e1",
              borderLeft: "4px solid #f59e0b",
              borderRadius: "4px",
              color: "#92400e",
              fontSize: "18px",
            }}
          >
            <strong>Note:</strong> Please recheck all details carefully, as
            policy amendments will not be possible later.
          </p>
          <br />
          <Cols>
            <Col8
              style={{
                color: "darkblue",
                "margin-left": "150px",
                "font-size": "25px",
              }}
            >
              Do you want to proceed with Marine Insurance?
            </Col8>
            {/* <Col2>
              <div>
                {options.map((o, i) => (
                  <label key={i}>
                    {o + " "}
                    <input
                      type="checkbox"
                      checked={i === selected}
                      onChange={() => onChange(i)}
                    />
                    <br></br>
                  </label>
                ))}
              </div>
            </Col2> */}
          </Cols>
          <br />
          <button
            class="button is-danger"
            style={{ float: "right" }}
            onClick={async () => {
              data(0);
              if(bookingsStore.current.isInsuranceOptCheck==='No'){
                const addmarine = (rec, d) => {
                  if (bookingsStore.current.premium > offerPremiumValue) {
                      const chargesList = bookingsStore.current.contract.chargesList;
                      const updatedChargesList = chargesList.filter(e => e.chargeDescription !== "Marine Insurance");
                      if (bookingsStore.current.contract.shipmentType.toLowerCase().indexOf("fcl") == -1) {
                          updatedChargesList.push({
                              id:rec.chargesList[rec.chargesList.length-1].id+1,
                              onaccount: "On Your Account",
                              chargeDescription: "Marine Insurance",
                              currency: "INR",
                              isIncluded: "Yes",
                              perShipment: 0,
                              total: ((bookingsStore.current.premium - offerPremiumValue)).toFixed(2),
                          });
                      } else {
                          let l = {
                              id:rec.chargesList[rec.chargesList.length-1].id+1,
                              onaccount: "On Your Account",
                              chargeDescription: "Marine Insurance",
                              currency: "INR",
                              isIncluded: "Yes"
                          }
                          for (let i = 0; i < bookingsStore.current.contract.containerList.length; i++) {
                              let cn = bookingsStore.current.contract.containerList[i]["containerType"]
                              if (i == 0) {
                                  l[cn + "perShipment"] = ((bookingsStore.current.premium - offerPremiumValue)).toFixed(2)
                                  l[cn + "total"] = ((bookingsStore.current.premium - offerPremiumValue)).toFixed(2)
                              } else {
                                  l[cn + "perShipment"] = 0
                                  l[cn + "total"] = 0
                              }
                          }
                          updatedChargesList.push(l);
                      }
                      rec.chargesList = JSON.parse(JSON.stringify(updatedChargesList));
                      rec.quoteValue = d.quoteValue + (bookingsStore.current.premium - offerPremiumValue)
                      rec.quoteValueUSD = rec.quoteValue / configStore.getExchangeRate("USD")
                  } else {
                      const chargesList = bookingsStore.current.contract.chargesList;
                      const updatedChargesList = chargesList.filter(e => e.chargeDescription !== "Marine Insurance");
                      rec.chargesList = JSON.parse(JSON.stringify(updatedChargesList));
                      rec.quoteValue = d.quoteValue
                      rec.quoteValueUSD = rec.quoteValue / configStore.getExchangeRate("USD")
                  }
                  return rec
              }
              const setquotevalue= async(d)=>{
                let contract = JSON.parse(JSON.stringify(bookingsStore.current.contract))
                if(contract.multicharge==undefined || contract.multicharge.length==0){
                  contract = addmarine(contract,d,data)
                  bookingsStore.current.contract = JSON.parse(JSON.stringify(contract))
                }else{
                  for (let i = 0; i < contract.multicharge.length; i++) {
                    contract.multicharge[i]=addmarine(contract.multicharge[i],d,data)
                  }
                  bookingsStore.current.contract = JSON.parse(JSON.stringify(contract))
                }
                await MonApi.apost(UPDATE_BOOKING_FIELDS_URI, {
  _id: bookingsStore.current._id,
  contract: bookingsStore.current.contract
})
              }
              if(bookingsStore.current.contractNum!== 'SPOT') Api.getContractsdata(bookingsStore.current.contract._id,setquotevalue)
              }
              setSelected();
              configStore.coiModalVisible1 = false;
            }}
          >
            Submit
          </button>
          <button
            class="button is-warning"
            onClick={() => {
              setSelected();

              configStore.coiModalVisible1 = false;
            }}
          >
            Cancel
          </button>
        </section>
      </div>
    </div>
  );
}

export function PremiumInsurance(props) {
  useSnapshot(dtactionStore);
  useSnapshot(taskStore);
  useSnapshot(configStore);
  useSnapshot(contractsStore);
  useSnapshot(bookingsStore);
  useSnapshot(containerStore)
  let brec = bookingsStore.current;
  let rec = contractsStore.current;
  let oldrec = contractsStore.old;
  const defaultInsuranceValue = 12000;
  const offerPremiumValue = 500;
  const [amount, setAmount] = useState(defaultInsuranceValue);
  const [entityData, SetEntityData] = useState(null);
  const [inputModified, setInputModified] = useState(false); // Track if input was modified
  const [premium, setPremium] = useState(null);
  const [hasError, setHasError] = useState(false); // New state to track input error
  const [disabledButton, setDisabledButton] = useState(oldrec.commodityType!==''?true:false)

  //console.log("entityData", rec);
  //console.log("entityData1", brec);
  console.log("aa",configStore.getExchangeRate("USD"))

  const getEntitydata = async () => {
    let entityData = await EntityApi.viewEntity(rec?.entityId);

    console.log("entityData", entityData);
    ///console.log("entityData", task.entityId);

    return entityData;
  };
  useEffect(() => {
    getEntitydata().then((data1) => {
      SetEntityData(data1);
    });
  }, []);
  let modalClass = "modal";
  if (configStore.coiModalVisible2) modalClass += " is-active";
  const [error,setError] = useState(false)
  const handleSubmit = async () => {
    if (amount==""||rec.commodityType=='' ) {
      // If the input is empty, show error
      if(rec.commodityType=='') setError(true)
      if(amount=="") setHasError(true);
      return;
    } 
    
    else{
      setHasError(false);
      setError(false);
      configStore.coiModalVisible2 = false;
      let policyType;
      let orginCountry = Utils.extractCountry(rec.origin);
      let destinationCountry = Utils.extractCountry(rec.destination);
      if (entityData?.entityCountry == orginCountry) {
        policyType = "Export";
      }
      if (entityData?.entityCountry == destinationCountry) {
        policyType = "Import";
      }
      await Api.CoiPremium(
        {
          Transit_Type: policyType,
          CommodityId: commodityType[rec.commodityType],
          Invoice_Value: amount * configStore.getExchangeRate("USD"),
          Transit_From_Country: orginCountry,
          Transit_To_Country: destinationCountry,
          contractID: rec._id,
          amount:amount,
          insuranceusd:configStore.getExchangeRate("USD")
  
        },
        async (data) => {
          console.log("ahhh23",contractsStore.current.shipmentType,contractsStore.current.containerList)
          loader.show()
          console.log("ahhh", data);
          if (data.status == "success") {
            const addmarine = (rec,d,data) =>{  
              if(data.premium>offerPremiumValue){
                const chargesList = rec.chargesList;
                const updatedChargesList = chargesList.filter(e => e.chargeDescription !== "Marine Insurance");
               if(contractsStore.current.shipmentType.toLowerCase().indexOf("fcl")==-1){
                updatedChargesList.push({
                  id:rec?.chargesList?.length > 0 ? rec.chargesList[rec.chargesList.length-1].id+1:1,
                  onaccount:"On Your Account",
                  chargeDescription: "Marine Insurance",
                  currency: "INR",
                  isIncluded: "Yes",
                  perShipment: 0,
                  total: ((data.premium-offerPremiumValue)).toFixed(2),
                });
               }else{
                let l = {
                  id:rec?.chargesList?.length > 0 ? rec.chargesList[rec.chargesList.length-1].id+1:1,
                  onaccount:"On Your Account",
                  chargeDescription: "Marine Insurance",
                  currency: "INR",
                  isIncluded: "Yes"
                }
                for (let i = 0; i < contractsStore.current.containerList.length; i++) {
                  let cn = contractsStore.current.containerList[i]["containerType"]
                  if(i==0){
                    l[cn+"perShipment"] = ((data.premium-offerPremiumValue)).toFixed(2)
                    l[cn+"total"] = ((data.premium-offerPremiumValue)).toFixed(2)
                  }else{
                    l[cn+"perShipment"] = 0
                    l[cn+"total"] = 0
                  }
                }
                updatedChargesList.push(l);
               }
               rec.chargesList = JSON.parse(JSON.stringify(updatedChargesList));
               rec.quoteValue = d.quoteValue+(data.premium-offerPremiumValue)
               rec.quoteValueUSD = rec.quoteValue/configStore.getExchangeRate("USD")                
               rec.isInsured = 'Yes'             
              }else{
                const chargesList = rec.chargesList;
                const updatedChargesList = chargesList.filter(e => e.chargeDescription !== "Marine Insurance");
                rec.chargesList = JSON.parse(JSON.stringify(updatedChargesList));
                rec.quoteValue = d.quoteValue
                rec.quoteValueUSD = rec.quoteValue/configStore.getExchangeRate("USD")
                rec.isInsured = 'Yes'
              }
              return rec
            }
            
              const setquotevalue=(d)=>{
                let contract = JSON.parse(JSON.stringify(rec))
                if(contract.multicharge==undefined || contract.multicharge.length==0){
                  contract = addmarine(contract,d,data)
                  contractsStore.current = JSON.parse(JSON.stringify(contract))
                }else{
                  for (let i = 0; i < contract.multicharge.length; i++) {
                    contract.multicharge[i]=addmarine(contract.multicharge[i],d,data)
                  }
                  contractsStore.current = JSON.parse(JSON.stringify(contract))
                }
               }
                Api.getContractsdata(contractsStore.current._id,setquotevalue)
            setTimeout(() => {
              loader.hide()
              props.data(true)
              configStore.setModalMessage("Hurray ! Your Premium for Marine Insurance has been applied.");
            }, 2000);
          } else{
            loader.hide()
          if(data.message.includes('CommodityId Missing')){
            configStore.setModalMessage('Marine insurance is not available for this commodity type.');
          }else{
            configStore.setModalMessage(data.message);
          }  
          }
        }
      );
      setAmount(defaultInsuranceValue);
   
    }
     };
  const getPremium = async () => {
    let policyType;
    let orginCountry = Utils.extractCountry(rec.origin);
    let destinationCountry = Utils.extractCountry(rec.destination);
    if (entityData?.entityCountry == orginCountry) {
      policyType = "Export";
    }
    if (entityData?.entityCountry == destinationCountry) {
      policyType = "Import";
    }
    loader.show()
    await Api.CoiPremium(
      {
        Transit_Type: policyType,
        CommodityId: commodityType[rec.commodityType],
        Invoice_Value: amount * configStore.getExchangeRate("USD"),
        Transit_From_Country: orginCountry,
        Transit_To_Country: destinationCountry,
        contractID: rec._id,
        amount:amount,
        insuranceusd:configStore.getExchangeRate("USD")

      },
      async (data) => {
        setPremium(data.premium);
        if (data.status == "success") {
          loader.hide()
          setPremium(data.premium);
        } else{
          loader.hide()
          if(data.message.includes('CommodityId Missing')){
            configStore.setModalMessage('Marine insurance is not available for this commodity type.');
          }else{
            configStore.setModalMessage(data.message);
          }
        }
      }
    );
  };
  useEffect(() => {
    if (amount > defaultInsuranceValue && rec.commodityType!=='' ) {
      getPremium();
    }
  }, [amount, inputModified,rec.commodityType]);
  return (
    <div
      className={modalClass}
      // onClick={async () => {
      //   if (inputModified && !isTyping) {
      //     handleSubmit(); // Only call handleSubmit if input was modified
      //   }
      //   if (inputModified == false && amount <= 12000 && !isTyping) {
      //     handleSubmit();
      //   }
      // }}
    >
      <div className="modal-background"></div>
      <div
        className="modal-card"
        onClick={(e) => {
        e.stopPropagation();
        }}
        style={{ borderRadius: "10px", width: "900px" }}
      >
        <section className="modal-card-body">
        <div className="field">
            <label className="label is-medium" style={{ marginBottom: '0px' }}>Commodity Type*</label>
            <div className="control">
                <div className={ !error ? "select is-small" : "select is-small is-danger" }>
                    <select value={rec.commodityType} disabled={disabledButton}  onChange={(e) => {
                            setError(false);
                            rec.commodityType = e.target.value
                        }} >
                        <option selected value={''} hidden>
                            {''}
                        </option>
                        {rec.hazardous == 'No'?
                        commodityList.filter(val => val !== '').map(val => <option key={val}>{val}</option>):
                        hazardousList.filter(val => val !== '').map(val => <option key={val}>{val}</option>)}
                    </select>
                </div>
            </div>
        </div>          
        <Cols>
            <Col4 style={{ color: "darkblue" }}>
              Insurance Declared Value (IDV) :
            </Col4>
            <Col5>
              <div class="field">
                <div
                  class="input-d-wrapper"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    position: "relative",
                  }}
                >
                  <input
                    className={"input"}
                    type="number"
                    value={amount}
                    // onFocus={() => setIsTyping(true)} // User starts typing
                    // onBlur={() => setIsTyping(false)} // User stops typing
                    onChange={(event) => {
                      if (event.target.value.length <= 15) {
                        setAmount(event.target.value);
                        //setInputModified(true);
                        setHasError(false)
                      }
                    }}
                    style={{
                      borderColor: hasError ? "red" : "inherit", // Add red border if error exists
                    }}
                    onKeyDown={(e) =>
                      ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                    }
                  />
                  <div
                    style={{
                      width: "70px",
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#1B6B93",
                      color: "#fff",
                      border: "0 10px 10px 0",
                      position: "absolute",
                      outline: "2px solid #1B6B93",
                      cursor: "pointer",
                    }}
                  >
                    USD
                    {/* <img
                      src="./assets/chevron-white.png"
                      alt="chevron"
                      class="chevron-3"
                    /> */}
                    {/* <div class="currency-div d-none">
                      <ul>
                        <li>INR</li>
                        <li>USD</li>
                        <li>DNR</li>
                        <li>EUR</li>
                        <li>DIR</li>
                        <li>QSD</li>
                      </ul>
                    </div> */}
                  </div>
                </div>
              </div>
              {hasError && <p style={{ color: "red" }}>IDV value should not be empty.</p>} {/* Error message */}
            </Col5>
          </Cols>
          <Cols>
            {amount <= defaultInsuranceValue ? (
              <p style={{ marginLeft: "12px" }}>
                You can increase the IDV as per your needs,subject to additional
                premium.
              </p>
            ) : (
              <>
                <div style={{ marginLeft: "12px" }}>
                  <p>
                    You can increase the IDV as per your needs, subject to
                    additional premium.
                  </p>
                  <br></br>
                  <p style={{ fontWeight: "bold" }}>
                    In case of a claim 1 %, of consignment value is the excess.
                  </p>
                </div>
              </>
            )}
          </Cols>
          <Cols>
            <Col8>
              {amount == defaultInsuranceValue || amount < defaultInsuranceValue ? (
                <p style={{ color: "green" }}>
                  No Additional Premium Applicable.
                </p>
              ) : (
                <p style={{ fontWeight: "bold" }}>
                  Additional Premium Of{" "}
                  <span style={{ color: "green" }}>
                    INR {premium > offerPremiumValue ? (premium - offerPremiumValue).toFixed(2) : 0}
                  </span>{" "}
                  Applicable
                </p>
              )}
            </Col8>
          </Cols>
          <br />
          <button
            class="button is-danger"
            style={{ float: "right" }}
            onClick={async () => {
              //configStore.coiModalVisible2 = false;
              handleSubmit();
            }}
          >
            Submit
          </button>
          <button
            class="button is-warning"
            onClick={(e) => {
              e.stopPropagation(); // Prevent event bubbling
              setAmount(defaultInsuranceValue);
              setError(false);
              setHasError(false)
              //setInputModified(false); // Reset input modified state
              configStore.coiModalVisible2 = false;
            }}
          >
            Cancel
          </button>
        </section>
      </div>
    </div>
  );
}
